import { EnvironmentProviders, Provider, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from "@angular/core";
import { provideRouter, TitleStrategy, withComponentInputBinding, withInMemoryScrolling, withRouterConfig } from "@angular/router";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideTransloco, provideTranslocoMissingHandler } from "@jsverse/transloco";
import { AzmTranslocoMissingHandler } from "@azm/core/i18n/azm-transloco-missing-handler";

import TranslocoHttpLoader from "transloco.loader";
import translocoConfigurations from "transloco.config";
import {
	loadingInterceptor,
	refreshTokenInterceptor,
	errorInterceptor,
	successInterceptor,
	tokenInterceptor,
	latinDigitsInterceptor,
} from "@azm/core/interceptors";
import { TitleService } from "@azm/core/services/title";
import { routes } from "../app.routes";

import { provideAppBootstrapInitializer } from "./initializers/app-bootstrap.initializer";

const interceptors = [
	loadingInterceptor,
	refreshTokenInterceptor,
	errorInterceptor,
	tokenInterceptor,
	latinDigitsInterceptor,
	successInterceptor,
];

export function provideAppConfig(): (Provider | EnvironmentProviders)[] {
	return [
		provideBrowserGlobalErrorListeners(),
		provideZonelessChangeDetection(),
		provideRouter(
			routes,
			withComponentInputBinding(),
			withRouterConfig({ paramsInheritanceStrategy: "always" }),
			withInMemoryScrolling({ anchorScrolling: "enabled", scrollPositionRestoration: "enabled" }),
		),
		provideHttpClient(withInterceptors(interceptors)),
		provideAppBootstrapInitializer(),
		provideTransloco({
			config: translocoConfigurations,
			loader: TranslocoHttpLoader,
		}),
		provideTranslocoMissingHandler(AzmTranslocoMissingHandler),
		{ provide: TitleStrategy, useClass: TitleService },
	];
}
